'use strict'

import ApiClient from './ApiClient'
import qs from 'qs'

export default class PvtagRepository {
  /**
   * 個人タグ一覧取得
   * @param {object} params
   * @returns {*}
   */
  getList (params) {
    return ApiClient().get(`/personal-settings/tags`, { params })
  }

  /**
   * 個人タグ作成
   * @param data 登録値
   * @returns {*}
   */
  post (data) {
    return ApiClient().post(`/personal-settings/tags`, qs.stringify(data))
  }

  /**
   * 個人タグ情報取得
   * @param id ID
   * @returns {*}
   */
  get (id) {
    return ApiClient().get(`/personal-settings/tags/${id}`)
  }

  /**
   * 個人タグ更新
   * @param id id
   * @param params 登録値
   * @returns {*}
   */
  put (id, params) {
    return ApiClient().put(`/personal-settings/tags/${id}`, params)
  }

  /**
   * 個人タグ削除
   * @param id id
   * @returns {*}
   */
  delete (id) {
    return ApiClient().delete(`/personal-settings/tags/${id}`)
  }

  /**
   * 指定された複数IDの個人タグ情報を一括削除します。
   * @param {object} data
   * @returns {*}
   */
  bulkDelete (data) {
    return ApiClient().post(`/personal-settings/tags/delete`, data)
  }

  /**
   * 選択された複数IDの表示順を別の場所に移動します
   * @param {object} params
   * @returns {*}
   */
  sort (params) {
    return ApiClient().put(`/personal-settings/tags/sort`, params)
  }

  /**
   * タグカラー一覧を取得する
   * @returns {*}
   */
  getColors () {
    return ApiClient().get('/personal-settings/tags/colors')
  }
  //
  // /**
  //  * タグ選択ダイアログ用のタグ情報一覧を取得します。
  //  * @param {object} params
  //  * @returns {*}
  //  */
  // getSelTags (params) {
  //   return ApiClient().get(`/personal-settings/tags/seltags`, { params })
  // }
}



// WEBPACK FOOTER //
// ./src/repositories/PvtagRepository.js